import { Box, Text, useColorModeValue } from '@chakra-ui/react'

export default function Footer() {
  // Dracula theme colors
  const textColor = useColorModeValue('#6272a4', '#6272a4')

  return (
    <Box
      as="footer"
      textAlign="center"
      py="6"
      mt="auto"
      fontFamily="mono"
      fontSize="sm"
      color={textColor}
    >
      <Text>built with ❤️ and ☕</Text>
    </Box>
  )
}
